import { render, staticRenderFns } from "./CompetenceDialog.vue?vue&type=template&id=c69ee170&scoped=true&lang=pug&"
import script from "./CompetenceDialog.vue?vue&type=script&lang=ts&"
export * from "./CompetenceDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69ee170",
  null
  
)

export default component.exports